<app-page-content>
<app-doenkids-menu-bar menuBar [showBackButton]="true"></app-doenkids-menu-bar>
<div content>
  <app-review-input></app-review-input>
</div>
</app-page-content>
